module.exports = __webpack_public_path__ + "images/bosch1ac20c25bc18dd9340a180093d2e34bf.png";